import React from 'react';

const Popup = ({body, title, actionButtons}) => (
	<div className="pp-modal">
		<div className="pp-popup">
			{title &&
				<p className="pp-popup-title">{title}</p>
			}
			{body &&
				<p className="pp-popup-body">{body}</p>
			}
			{actionButtons &&
				<div className="pp-action-buttons">
					{actionButtons}
				</div>
			}
		</div>
	</div>
)

export default Popup;



// WEBPACK FOOTER //
// ./src/components/Popup.js